import React from 'react'

class Header extends React.Component {
  render () {
    return (
      <nav className="header">
        <div className="pull-left">
          <h1>
            <a href="/">Demo Store</a>
          </h1>
        </div>
      </nav>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/js/components/header.jsx